import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  btn: {
    border: 'none',
    cursor: 'pointer',
    minWidth: 'fit-content',

    fontWeight: 400,
    textTransform: 'none',

    '&:disabled': {
      cursor: 'not-allowed',
    },

    '&:hover': {
      opacity: 0.7,
    },
  },
  
  variant_primary: {
    backgroundColor: theme.palette.blue2,
    color: theme.palette.white,

    '&:disabled': {
      backgroundColor: theme.palette.grey5,
      color: theme.palette.white,
    },

    '&:hover': {
      backgroundColor: theme.palette.blue2,
    }
  },

  variant_secondary: { },

  variant_light: {
    backgroundColor: theme.palette.white,
    border: `1px solid ${theme.palette.grey4}`,
    color: theme.palette.black,

    '&:hover': {
      backgroundColor: '#fdeded',
      borderColor: '#d32f2f',
      color: '#d32f2f',
      opacity: 1,
    },
  },

  size_small: {
    fontSize: '14px',
    height: '28px',
    borderRadius: ' 16px',
    padding: '6px 24px'
  },

  size_regular: {
    fontSize: '14px',
    height: '40px',
    borderRadius: '8px',
    padding: '12px 18px'
  },

  size_large: {
    fontSize: '18px',
    height: '48px',
    borderRadius: '12px',
    padding: '12px 20px'
  },

  fullWidth: {
    width: '100%',
  },
}));